<template>
    <SearchPage></SearchPage>
</template>

<script setup>
import { onBeforeMount, onMounted, watch } from 'vue'
import { storeToRefs } from 'pinia'
import SearchPage from './components/SearchPage.vue'
import { useFilterStore } from './stores/filter-store'
import { useSearchStore } from './stores/search-store'

const { establishFilters, } = useFilterStore()
const { initializeSearchPage, searchProducts, searchArticles, debounce } = useSearchStore()
const { filterPills } = storeToRefs(useFilterStore())
const { startPage, articlesStartPage } = storeToRefs(useSearchStore())

onBeforeMount(async () => {
    establishFilters()
    initializeSearchPage()
})

const executeSearch = async () => {
  startPage.value = 1
  articlesStartPage.value = 1
  searchProducts()
  searchArticles()
}

const debouncedFn = debounce(executeSearch, 600);

onMounted(async () => debouncedFn())

watch(filterPills, async () => debouncedFn())
// watch(searchedString, async () => debouncedFn())
</script>
